import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import config from "config";
import {getCookie, setCookie} from "../reducers/cookies";
import Splash from "./Splash";
const UNSET_COOKIE = 'UNSET_COOKIE';

require('./Splash.scss');

export class PureSplash extends Component {

  constructor(props) {
    super(props);

    this.triggers = ['siteLoad', 'login'];
    this.state = {
      justSawASplash: false
    }
  }

  componentDidUpdate(prevProps) {
    const { splashpages, fetchSplashpageSeenProperty } = this.props;

    this.triggers.forEach(trigger => {
      if(splashpages[trigger] && !prevProps.splashpages[trigger]) {
        fetchSplashpageSeenProperty(this.props.splashpages[trigger].id)
      }
    })
  }

  handleClose = (trigger) => (id, endDateTime) => {
    if (trigger === 'login') {
      this.setState({
        ...this.state,
        justSawASplash: true
      });
    }

    this.props.setSplashpageSeen(`${config.splashpage.cookieName}_${id}`, endDateTime);
  };

  render(){
    const { splashpages, cookies } = this.props;
    const { justSawASplash } = this.state;
    const shouldDisplayFromCookie = checkCookies(cookies);

    const siteLoadSplash = splashpages.siteLoad;
    const loginSplash = splashpages.login;

    const showLoginSplash = loginSplash && shouldDisplayFromCookie(loginSplash.id);
    const showSiteLoadSplash = !showLoginSplash && siteLoadSplash && shouldDisplayFromCookie(siteLoadSplash.id);

    if (!justSawASplash && (showLoginSplash || showSiteLoadSplash)) {
      return (
        <React.Fragment>
          { showLoginSplash &&
            <Splash
              data={loginSplash}
              handleClose={this.handleClose('login')}
            />
          }
          { showSiteLoadSplash &&
            <Splash
              data={siteLoadSplash}
              handleClose={this.handleClose('siteLoad')}
            />
          }
        </React.Fragment>
    )}

    return null
  }
}

function checkCookies(cookies) {
  return cookieId => {
    const cookieForSp = cookies[`${config.splashpage.cookieName}_${cookieId}`];
    // if undefined, cookie not received yet return false to prevent splash page flashing up
    if (typeof cookieForSp === 'undefined') {
      return false
    }

    return cookieForSp === UNSET_COOKIE;
  }
}

PureSplash.propTypes = {
  splashpages: PropTypes.object,
  setSplashpageSeen: PropTypes.func,
  fetchSplashpageSeenProperty: PropTypes.func,
  cookies: PropTypes.object
};

const mapStateToProps = (state) => {
  const { splashpage, cookies } = state.common;

  return {
    splashpages: splashpage,
    cookies
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSplashpageSeen: (id, expiryDate) => dispatch(setCookie(
      id,
      config.splashpage.cookieValue,
      {
        path: "/",
        expires: new Date(expiryDate)
      })),
    fetchSplashpageSeenProperty: (id) => dispatch(getCookie(`${config.splashpage.cookieName}_${id}`, UNSET_COOKIE))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PureSplash);



// WEBPACK FOOTER //
// ./modules/Common/components/SplashContainer.js